import InventoryIcon from '@mui/icons-material/Inventory';

export const SupplyIcon = () => <InventoryIcon />;
